var map = {
	"./events-cat-cn.webp": 2011,
	"./events-cat.webp": 2012,
	"./games-cat.webp": 2013,
	"./live-casino-cat-cn.webp": 2014,
	"./live-casino-cat.webp": 2015,
	"./lottery-cat.webp": 2016,
	"./other-cat.webp": 2017,
	"./p2p-cat.webp": 2018,
	"./pd-table.webp": 2019,
	"./privacy-policy-title-bm.webp": 2020,
	"./privacy-policy-title-cn.webp": 2021,
	"./privacy-policy-title-id.webp": 2022,
	"./privacy-policy-title.webp": 2023,
	"./promos-1.webp": 2024,
	"./promos-2.webp": 2025,
	"./promos-3.webp": 2026,
	"./promos-4.webp": 2027,
	"./question.webp": 2028,
	"./sideBar-bg.webp": 2029,
	"./slot-cat-cn.webp": 2030,
	"./slot-cat.webp": 2031,
	"./special-cat-cn.webp": 2032,
	"./special-cat.webp": 2033,
	"./sports-cat-cn.webp": 2034,
	"./sports-cat.webp": 2035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;